import { toast } from 'react-toastify';
import { isValidEmail } from '../../../utils/utils-generat';
import { NavigateFunction } from 'react-router/dist/lib/hooks';
import appApi from '../../../api/app-api';

export const logInOperation = async (
  mail: string | undefined,
  password: string | undefined,
  navigate: NavigateFunction,
  setLoading: (loading: boolean) => void,
) => {
  const redirectAfterLoginStorageKey = 'redirectAfterLogin';
  try {
    if (!mail || !isValidEmail(mail)) {
      toast.warn('יש להזין כתובת מייל תקינה');
      return;
    }

    if (!password || password.length < 8) {
      toast.warn('על הסיסמא להיות באורך הגדול משמונה תווים');
      // return;
    }
    setLoading(true);

    await appApi.login(mail, password);
    const redirectPath =
      sessionStorage.getItem(redirectAfterLoginStorageKey) ?? '/';
    sessionStorage.removeItem(redirectAfterLoginStorageKey);
    setTimeout(async () => {
      setLoading(false);
      navigate(redirectPath, { replace: true });
    }, 500);

    // TODO api call
  } catch (e) {
    setLoading(false);
    console.error(`logInOperation with the mail: ${logInOperation} is failed`);
    toast.error('ההתחברות נכשלה יש להזין מייל וסיסמא תקינים');
  }
};
